import {
  IdleTimeoutProvider,
  UserProfileProvider,
} from '@hakimo-ui/hakimo/providers';
import { RootLayout } from '@hakimo-ui/hakimo/ui-layout';
import { NavItem } from '@hakimo-ui/hakimo/ui-navigation';
import { escalationAudioNotifyAtom } from '@hakimo-ui/hakimo/util';
import { useAtomValue } from 'jotai';
import { Outlet } from 'react-router-dom';
import AuthHandler from '../auth/AuthHandler';
import AppInit, { AppInitOptions } from '../init/AppInit';
import FeedbackButton from '../feedback/FeedbackButton';
import GlobalEscalationAlert from './GlobalEscalationAlert';
import Toaster from './Toaster';

interface Props {
  navItems: NavItem[];
  appInitOptions: AppInitOptions;
  enableGlobalEscalationAlert?: boolean;
}

export function AppMain(props: Props) {
  const { navItems, appInitOptions, enableGlobalEscalationAlert } = props;
  const escalationAudioNotify = useAtomValue(escalationAudioNotifyAtom);

  return (
    <AuthHandler>
      <UserProfileProvider>
        <IdleTimeoutProvider>
          <AppInit options={appInitOptions} />
          {enableGlobalEscalationAlert && escalationAudioNotify && (
            <GlobalEscalationAlert />
          )}
          <RootLayout navItems={navItems}>
            <div className="dark:bg-dark-bg h-full bg-white">
              <Outlet />
              <Toaster />
              <FeedbackButton />
            </div>
          </RootLayout>
        </IdleTimeoutProvider>
      </UserProfileProvider>
    </AuthHandler>
  );
}

export default AppMain;
